import { render, staticRenderFns } from "./TagField.vue?vue&type=template&id=6479da71"
import script from "./TagField.ts?vue&type=script&lang=ts&external"
export * from "./TagField.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports